const faqButtons = document.querySelectorAll(".Faq__Question");

faqButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const answer = document.getElementById(
      button.getAttribute("aria-controls"),
    );
    const expanded = button.getAttribute("aria-expanded") === "true";

    // Toggle ARIA states
    button.setAttribute("aria-expanded", !expanded);
    answer.setAttribute("aria-hidden", expanded);

    // Toggle custom data attribute for styling
    const faqItem = button.closest(".Faq__Item");
    faqItem.setAttribute("data-is-open", !expanded);
  });
});
